var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 120,
    viewBox: "0 0 110 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500024 78.8809V78.8801V41.0678C0.55122 37.3126 1.56971 33.6354 3.4555 30.3963C5.34183 27.1563 8.03114 24.466 11.2595 22.5888L11.2622 22.5872L43.7887 3.40367C43.7891 3.40343 43.7895 3.40318 43.79 3.40293C47.0604 1.50109 50.7698 0.5 54.5455 0.5C58.3216 0.5 62.0315 1.50135 65.3022 3.40367L65.3024 3.40374L97.8313 22.3115C97.8314 22.3116 97.8314 22.3116 97.8315 22.3116C101.099 24.2121 103.813 26.9449 105.702 30.2365C107.591 33.5281 108.587 37.2625 108.591 41.0649V78.8801V78.8809C108.596 82.6925 107.605 86.4381 105.715 89.74C103.826 93.0419 101.107 95.7834 97.8315 97.6884C97.8314 97.6884 97.8314 97.6885 97.8313 97.6885L65.3024 116.596L65.3022 116.596C62.0315 118.499 58.3216 119.5 54.5455 119.5C50.7693 119.5 47.0594 118.499 43.7887 116.596L43.7886 116.596L11.2596 97.6885C11.2595 97.6885 11.2595 97.6884 11.2594 97.6884C7.9841 95.7834 5.26464 93.0419 3.37552 89.74C1.48636 86.4381 0.494446 82.6925 0.500024 78.8809Z",
    fill: "white",
    stroke: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7274 78.75C62.7274 74.0625 59.0456 70.2273 54.5456 70.2273C49.9433 70.2273 46.3638 74.0625 46.3638 78.75C46.3638 83.5441 49.9433 87.2728 54.5456 87.2728C59.0456 87.2728 62.7274 83.5441 62.7274 78.75ZM47.2842 35.4972L48.6138 64.4745C48.716 65.7529 49.841 66.8182 51.0683 66.8182H57.9206C59.1479 66.8182 60.2729 65.7529 60.3751 64.4745L61.7047 35.4972C61.807 34.0057 60.682 32.7273 59.2501 32.7273H49.7388C48.307 32.7273 47.182 34.0057 47.2842 35.4972Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWt);
export default __webpack_public_path__ + "static/media/warning-wt.f32e61842609ad20bf64bfacdb32db0b.svg";
export { ForwardRef as ReactComponent };